import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
const CustomButton = ({ className, onClick, onTouchEnd, onTouchStart, loading, children, operationEnded }) => {
    const baseClasses = "button-primary button--bg-gradient-primary264g button--rounded button--full";
    return (_jsxs("button", { className: classNames(baseClasses, className), onClick: onClick, onTouchEnd: onTouchEnd, onTouchStart: onTouchStart, children: [children, loading && !operationEnded && (_jsx("span", { className: "spinner", style: {
                    display: "inline-block",
                    verticalAlign: "middle",
                    position: "relative",
                    right: "-1rem",
                } }))] }));
};
export default CustomButton;
